import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';
import { UserDataToken } from 'types';

type Data = UserDataToken;

type Payload = {
  username: string;
};

export const usersGenerateToken = createApiSlice<Data, Payload>({
  name: 'usersGenerateToken',
  *tryGenerator(_, { payload: { username } }) {
    const response: Data = yield call(amplifyClient, {
      method: 'post',
      url: getEndpointV2({ path: '/auth/user/:username/token', urlParams: { username } }),
    });

    return response;
  },
});

export const usersRefreshToken = createApiSlice<Data, Payload>({
  name: 'usersRefreshToken',
  *tryGenerator(_, { payload: { username } }) {
    const response: Data = yield call(amplifyClient, {
      method: 'put',
      url: getEndpointV2({ path: '/auth/user/:username/token', urlParams: { username } }),
    });

    return response;
  },
});
